import { cn } from "@plasma/utils/cn";
import type { OutputHTMLAttributes } from "react";

function Spinner({
  className,
  ...props
}: OutputHTMLAttributes<HTMLOutputElement>) {
  return (
    <output
      className={cn("flex items-center justify-center", className)}
      {...props}
    >
      <svg
        aria-hidden="true"
        className="text-muted-foreground size-5 animate-spin"
        fill="none"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>Loading spinner</title>
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        />
        <path
          className="opacity-75"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          fill="currentColor"
        />
      </svg>
      <span className="sr-only">Loading...</span>
    </output>
  );
}

export { Spinner };
